import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import FullScreenSpinner from './FullScreenSpinner';
import { getNextAuthRoute, hasFullAppAccess } from '../utils/authFlow';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const {
    isAuthenticated,
    isEmailVerified,
    isLoading,
    isMfaChallengeRequired,
    isMfaEnrolled,
  } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <FullScreenSpinner />;
  }

  const authState = {
    isAuthenticated,
    isEmailVerified,
    isMfaChallengeRequired,
    isMfaEnrolled,
  };

  if (!hasFullAppAccess(authState)) {
    return <Navigate to={getNextAuthRoute(authState)} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
